import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Row } from "react-bootstrap";
import moment from "moment/moment";
import { saveLoader } from "../../redux/slice/loaderNoti";
import CloseIcon from "@mui/icons-material/Close";
import {
  useBlockJwDoMutation,
  useLazyPropertyServiceQuery,
} from "../../redux/api/api";
import AddIcon from "@mui/icons-material/Add";
import { FaRegEdit } from "react-icons/fa";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";

const JustWalking = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [modal, setModal] = useState(false);
  const [details, setDetails] = useState({});
  const [amenities, setamenities] = useState([]);

  const [full_from_date, setfull_from_date] = useState("");
  const [full_from_dateErr, setfull_from_dateErr] = useState(false);
  const [btn, setBtn] = useState(false);

  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  // RTK QUERY
  const [propertyServiceApi] = useLazyPropertyServiceQuery();
  const [blockJwDoApi] = useBlockJwDoMutation();

  // JUST WALKING
  const getView = () => {
    propertyServiceApi({ id: location?.state?.data?.id, type: "just_walking" })
      .unwrap()
      .then((res) => {
        setDetails(res?.just_walking);
        setamenities(res?.amenities);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const minMaxDate = () => {
    var someDate = new Date();

    // min date
    someDate.setDate(someDate.getDate() + 1); //number  of days to add, e.x. 15 days
    var dateFormated = someDate.toISOString().substr(0, 10);
    setMinDate(dateFormated);

    // max date
    someDate.setDate(someDate.getDate() + 6); //number  of days to add, e.x. 15 days
    var dateFormateds = someDate.toISOString().substr(0, 10);
    setMaxDate(dateFormateds);
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
      minMaxDate();
    }
  }, []);

  const blockJwDo = () => {
    if (full_from_date?.length == 0) {
      setfull_from_dateErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("date", moment(full_from_date).format("YYYY-MM-DD"));
      formdata.append("service_price_id", details?.serviceprice?.id);
      formdata.append("type", "just_walking");

      setBtn(true);
      dispatch(saveLoader(true));
      blockJwDoApi(formdata)
        .unwrap()
        .then((res) => {
          setBtn(false);
          dispatch(saveLoader(false));
          if (res?.status == "success") {
            onClose(false);
            Swal.fire({
              text: res?.message,
              icon: "success",
            });
            getView();
          }
        })
        .catch((err) => {
          console.log("err", err);
          setBtn(false);
          dispatch(saveLoader(false));
        });
    }
  };

  const onClose = () => {
    setfull_from_date("");
    setfull_from_dateErr(false);
    setModal(false);
  };

  return (
    <div>
      <Row>
        {details?.id ? (
          <div className="col-md-12 d-flex">
            <div className="col-md-6">
              <div className="block-header add-btn-new">
                <button onClick={() => setModal(true)}>Block</button>
              </div>
            </div>
            <div className="col-md-6 d-flex ac-je">
              <div className="block-header add-btn-new">
                <button
                  onClick={() =>
                    navigate("/just-walk", {
                      state: {
                        type: location?.state?.type,
                        data: location?.state?.data,
                        item: location?.state?.data,
                        itemType: "edit",
                      },
                    })
                  }
                  className="text-nowrap d-flex ac-jc gap-1 f2"
                >
                  <FaRegEdit />
                  Edit
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-md-12 d-flex ac-je">
            <div className="block-header add-btn-new">
              <button
                onClick={() =>
                  navigate("/just-walk", {
                    state: {
                      type: location?.state?.type,
                      data: location?.state?.data,
                      item: location?.state?.data,
                    },
                  })
                }
                className="text-nowrap d-flex ac-jc gap-1 f2"
              >
                <AddIcon />
                Add
              </button>
            </div>
          </div>
        )}
      </Row>
      {details?.id && (
        <Row>
          <div className="user-detail-table mt-5">
            <table className="tabledetails table-borderless user-det w-100 mb-5">
              <thead>
                <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                  Just Walkin Details
                </th>
              </thead>
              {details?.serviceprice?.id && (
                <tbody>
                  <tr>
                    <td style={{ width: "40%" }}>Admin Commision</td>
                    <td>:</td>
                    <td>{details?.serviceprice?.admin_commission}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Adult Price</td>
                    <td>:</td>
                    <td>
                      {details?.serviceprice?.adult_price
                        ? "₹" + details?.serviceprice?.adult_price
                        : ""}
                    </td>
                  </tr>
                  {/* <tr>
                  <td style={{ width: "40%" }}>Child Price</td>
                  <td>:</td>
                  <td>{details?.serviceprice?.child_price}</td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Minimum Persons</td>
                  <td>:</td>

                  <td>{details?.serviceprice?.min_persons}</td>
                </tr> */}
                  <tr>
                    <td style={{ width: "40%" }}>Maximum Persons</td>
                    <td>:</td>
                    <td>{details?.serviceprice?.max_persons}</td>
                  </tr>
                  {/* <tr>
                  <td style={{ width: "40%" }}>Minimum Childrens</td>
                  <td>:</td>
                  <td>{details?.serviceprice?.min_childrens}</td>
                </tr>

                <tr>
                  <td style={{ width: "40%" }}>Maximum Childrens</td>
                  <td>:</td>
                  <td>{details?.serviceprice?.max_childrens}</td>
                </tr> */}
                  <tr>
                    <td style={{ width: "40%" }}>Weekend Days</td>
                    <td>:</td>
                    <td>{details?.weekend_days}</td>
                  </tr>
                  <tr className="foods-det">
                    <td style={{ width: "40%" }}>Weekend Percentage</td>
                    <td>:</td>
                    <td>{details?.weekend_percentage}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Amenities</td>
                    <td>:</td>
                    <td className="amenity-type">
                      <ul>
                        {amenities?.map((item, ind) => {
                          return (
                            <li key={ind}>
                              <img src={item?.image} />
                              {item?.name}
                            </li>
                          );
                        })}
                      </ul>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </Row>
      )}

      <Modal
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-3">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                Just Walkin Block
              </label>
              <button className="cust-btn" onClick={() => onClose(false)}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row className="mt-4">
            <div className="col-md-12 mb-4">
              <label className="f1 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                Select Date
              </label>
              <div className="full-date-pick">
                <DatePicker
                  selected={full_from_date}
                  onChange={(date) => {
                    setfull_from_date(date);
                  }}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  dateFormat="yyyy-MM-dd"
                  todayButton="Today"
                  className="form-control custom-select"
                  placeholderText="YYYY-MM-DD"
                  minDate={minDate}
                  maxDate={maxDate}
                />
              </div>
              {full_from_date?.length == 0 && full_from_dateErr && (
                <p className="err">Select Date</p>
              )}
            </div>
          </Row>
          <Row className="mt-4 d-flex ac-jc">
            <div className="col-md-2 text-center">
              <button
                className={`submit-btn ${btn ? "opacity-50" : ""}`}
                onClick={() => blockJwDo()}
                disabled={btn}
              >
                OK
              </button>
            </div>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default JustWalking;
